"use client";

import { TABLE, TD, TH } from "@/components/tool-kit/styles";

/*
 * A results table for the clinical-statistics widgets: a header row, a bold first
 * column that reads as the row's name, monospace numbers, and an optional highlighted
 * row. Every cell is a string the widget has already formatted, so the table owns no
 * vocabulary. Rows are positional — result tables have no ids — hence the index keys.
 */

export function DataGrid({
  caption,
  head,
  rows,
  highlight,
}: {
  caption?: string;
  head: readonly string[];
  rows: readonly (readonly string[])[];
  /** Index of a row to tint — the form the reader chose, say. */
  highlight?: number;
}) {
  return (
    <div className="overflow-x-auto rounded-lg border border-border bg-card">
      <table className={TABLE}>
        {caption ? (
          <caption className="px-3 pt-3 text-left text-muted-foreground text-sm">
            {caption}
          </caption>
        ) : null}
        <thead>
          <tr>
            {head.map((cell, index) => (
              // biome-ignore lint/suspicious/noArrayIndexKey: header names may repeat
              <th className={TH} key={index} scope="col">
                {cell}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map(([name, ...cells], rowIndex) => (
            <tr
              className={highlight === rowIndex ? "bg-primary/5" : ""}
              // biome-ignore lint/suspicious/noArrayIndexKey: positional result rows
              key={rowIndex}
            >
              <th className={`${TD} font-medium`} scope="row">
                {name}
              </th>
              {cells.map((cell, cellIndex) => (
                // biome-ignore lint/suspicious/noArrayIndexKey: positional cells
                <td className={`${TD} font-mono`} key={cellIndex}>
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

/** A line of working: monospace, muted, wrapping on narrow screens. */
export function WorkingLine({ children }: { children: string }) {
  return (
    <p className="font-mono text-muted-foreground text-sm leading-relaxed">
      {children}
    </p>
  );
}
